import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import AccountConstants from 'pages/admin/account-management/constants';
import {
    IAccount,
    IAccountState,
    IListAccountsSearchForm,
} from 'types/account';

const initialState: IAccountState = {
    accounts: [],
    account: null,
    accountsSearchForm: {
        searchKeyWord: '',
        status: [AccountConstants.status.ALL],
        startDate: '',
        type: [AccountConstants.status.ALL],
        endDate: '',
    },
};

const accountSlice = createSlice({
    name: 'account',
    initialState,
    reducers: {
        setAccounts: (state, action: PayloadAction<IAccount[]>) => {
            state.accounts = action.payload;
        },
        setAccountSearchForm: (
            state,
            action: PayloadAction<IListAccountsSearchForm>
        ) => {
            state.accountsSearchForm = {
                ...state.accountsSearchForm,
                ...action.payload,
            };
        },
        clearAccountSearchForm: (state) => {
            state.accountsSearchForm = initialState.accountsSearchForm;
        },
    },
});

export const { setAccounts, clearAccountSearchForm, setAccountSearchForm } =
    accountSlice.actions;

export default accountSlice.reducer;
